function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
jQuery.fn.extend({
  search_sort: function(arg) {
    
    // get args
    var search_sort = {
      url: window.location.href,
      select_input: $(this).selector,
      container: arg.container,
      grid_container: arg.grid_container,
      title_wrapper: arg.title_wrapper,
      date_wrapper: arg.pub_date,
      price_wrapper: arg.price_wrapper || ".money",
      range_wrapper: arg.range_wrapper || ".price-range-container",
      range_submit: arg.range_submit || "#sort_apply"
    };
    
    // sort options/values
    var sorting_options = {
      title_descending: "title-descending",
      title_ascending: "title-ascending",
      date_descending: "date-descending",
      date_ascending: "date-ascending",
      price_lowest: "price-lowest",
      price_highest: "price-highest",
      price_range: "price-range"
    };
    
      $(".select_orderby li a").on("click",function(e) {
   
      e.preventDefault();
        if( $(this).attr('href') == "manual"){
        window.location.reload();
        }else{
        $(".select_orderby li").removeClass('selected');
        $(this).parent().addClass('selected');
      var val = $(this).attr('href');
      if(val === sorting_options.title_descending) {
        search_sort.sortByTitleDescending();
        setCookie("sorting-option", sorting_options.title_descending, 365);
       // Cookies.set('sorting-option', sorting_options.title_descending);
      } 

      else if(val === sorting_options.title_ascending) {
        search_sort.sortByTitleascending();
        setCookie("sorting-option", sorting_options.title_ascending, 365);
      }  
      else if(val === sorting_options.date_descending) {
        search_sort.sortByDateDescending();
        setCookie("sorting-option", sorting_options.date_descending, 365);
      } 
      else if(val === sorting_options.date_ascending) {
        search_sort.sortByDateascending();
         setCookie("sorting-option", sorting_options.date_ascending, 365);
      } 
      

      else if(val === sorting_options.price_lowest) {
        search_sort.priceLowest();
         setCookie("sorting-option", sorting_options.price_lowest, 365);
      } 

      else if(val === sorting_options.price_highest) {
        search_sort.priceHighest();
          setCookie("sorting-option", sorting_options.price_highest, 365);
      }
      
      else if(val === sorting_options.price_range) {
        search_sort.priceRange();
          setCookie("sorting-option", sorting_options.price_range, 365);
      }
      
      if(val !== sorting_options.price_range) {
        $(search_sort.range_wrapper).addClass("hide");
      }
        }
      });
    // when select input changes
    $(search_sort.select_input).on("change",function() {
      var val = $(this).val();
      if(val === sorting_options.title_descending) {
        search_sort.sortByTitleDescending();
        Cookies.set('sorting-option', sorting_options.title_descending);
      } 

      else if(val === sorting_options.title_ascending) {
        search_sort.sortByTitleascending();
        Cookies.set('sorting-option', sorting_options.title_ascending);
      }  
      else if(val === sorting_options.date_descending) {
        search_sort.sortByDateDescending();
        Cookies.set('sorting-option', sorting_options.date_descending);
      } 
      else if(val === sorting_options.date_ascending) {
        search_sort.sortByDateascending();
        Cookies.set('sorting-option', sorting_options.date_ascending);
      } 
      

      else if(val === sorting_options.price_lowest) {
        search_sort.priceLowest();
        Cookies.set('sorting-option', sorting_options.price_lowest);
      } 

      else if(val === sorting_options.price_highest) {
        search_sort.priceHighest();
        Cookies.set('sorting-option', sorting_options.price_highest);
      }
      
      else if(val === sorting_options.price_range) {
        search_sort.priceRange();
        Cookies.set('sorting-option', sorting_options.price_range);
      }
      
      if(val !== sorting_options.price_range) {
        $(search_sort.range_wrapper).addClass("hide");
      }
    });
    
    // when price range submitted
    $(search_sort.range_submit).on("click", function(e) {
      e.preventDefault();
      search_sort.rangeSubmit();
    });
    
    
   // Sort date (Ascending)
    search_sort.sortByDateascending = function() {
      $.ajax({
        url: search_sort.url,
        dataType: "html",
        success: function(data) {
          var container = $(data).find(search_sort.container);
          var items = container.find(search_sort.grid_container);

          items.sort(function(a,b){
            var an = a.querySelector(search_sort.date_wrapper),
                bn = b.querySelector(search_sort.date_wrapper);

            if(an < bn) {
              return 1;
            }
            if(an > bn) {
              return -1;
            }
            return 0;
          });

          $(search_sort.container).html(items);
                    setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500); 
        }
      })
    }

              // Sort date (Descending)
    search_sort.sortByDateDescending = function() {
      $.ajax({
        url: search_sort.url,
        dataType: "html",
        success: function(data) {
          var container = $(data).find(search_sort.container);
          var items = container.find(search_sort.grid_container);

          items.sort(function(a,b){
            var an = a.querySelector(search_sort.date_wrapper),
                bn = b.querySelector(search_sort.date_wrapper);

            if(an > bn) {
              return 1;
            }
            if(an < bn) {
              return -1;
            }
            return 0;
          });

          $(search_sort.container).html(items);
                    setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500); 
        }
      })
    }
    // Sort Alphabetically (Descending)
    search_sort.sortByTitleDescending = function() {
      $.ajax({
        url: search_sort.url,
        dataType: "html",
        success: function(data) {
          var container = $(data).find(search_sort.container);
          var items = container.find(search_sort.grid_container);
          items.sort(function(a,b){ 
            var an = a.querySelector(search_sort.title_wrapper),
                bn = b.querySelector(search_sort.title_wrapper);

            if(an < bn) {
              return 1;
            }
            if(an > bn) {
              return -1;
            }
            return 0;
          });

          $(search_sort.container).html(items);
                    setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500); 
        }
      })
    }

    // Sort Alphabetically (Ascending)
    search_sort.sortByTitleascending = function() {
      $.ajax({
        url: search_sort.url,
        dataType: "html",
        success: function(data) { 
          var container = $(data).find(search_sort.container);
          var items = container.find(search_sort.grid_container);
          items.sort(function(a,b){
            var an = a.querySelector(search_sort.title_wrapper),
                bn = b.querySelector(search_sort.title_wrapper);

            if(an > bn) {
              return 1;
            }
            if(an < bn) {
              return -1;
            }
            return 0;
          });

          $(search_sort.container).html(items);
                    setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500); 
        }
      })
    }

    // Sort Price (Low to High)
    search_sort.priceLowest = function() {
      $.ajax({
        url: search_sort.url,
        dataType: "html",
        success: function(data) {
          var container = $(data).find(search_sort.container);
          var items = container.find(search_sort.grid_container);

          items.sort(function(a,b){
            var an = a.querySelector('.money'),
                bn = b.querySelector('.money');

            return an - bn;
          });

          $(search_sort.container).html(items);
                    setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500); 
        }
      })
    }

    // Sort Price (High to Low)
    search_sort.priceHighest = function() {
      $.ajax({
        url: search_sort.url,
        dataType: "html",
        success: function(data) {
          var container = $(data).find(search_sort.container);
          var items = container.find(search_sort.grid_container);

          items.sort(function(a,b){
            var an = a.querySelector(search_sort.price_wrapper),
                bn = b.querySelector(search_sort.price_wrapper);

            return bn - an;
          });

          $(search_sort.container).html(items);
          setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500);  
        }
      })
    }
    
    search_sort.priceRange = function() {
      $(search_sort.range_wrapper).removeClass("hide");
      
    }
    
    search_sort.rangeSubmit = function() {
      var min = $(search_sort.range_wrapper).find("#min-range").val();
      var max = $(search_sort.range_wrapper).find("#max-range").val();
      
      if(min >= 0 && max >= 0) {
        $.ajax({
          url: search_sort.url,
          dataType: "html",
          success: function(data) {
            var container = $(data).find(search_sort.container);
            var items = container.find(search_sort.grid_container);
            
            var new_array = $(items).filter(function(){
              var price = $( this ).find(search_sort.price_wrapper).text().replace(/[^0-9\\.]/g,'');
              
              price = parseInt(price);
              return price >= min && price <= max;
            });

            $(search_sort.container).html(new_array);
          setTimeout(function(){ 
          $(".product-item").removeClass('col-12');  
          $(".product-item").addClass('col-6');   
          $(".product-item").removeClass('col-md-12');  
          $(".product-item").addClass('col-md-5');   
          $(".product-item").removeClass('col-lg-12');  
          $(".product-item").addClass('col-lg-15'); 
          }, 500);               
          }
        })
      }
    }
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
    // Get options from cookies on page load
   var cooke_sorting_option = getCookie('sorting-option');
    if(cooke_sorting_option === sorting_options.title_descending) {
      $(search_sort.select_input).val(cooke_sorting_option).change();
      search_sort.sortByTitleDescending();
    } 

    else if(cooke_sorting_option === sorting_options.title_ascending) {
      $(search_sort.select_input).val(cooke_sorting_option).change();
      search_sort.sortByTitleascending();
    }

    else if(cooke_sorting_option === sorting_options.price_lowest) {
      $(search_sort.select_input).val(cooke_sorting_option).change();
      search_sort.priceLowest();
    }

    else if(cooke_sorting_option === sorting_options.price_highest) {
      $(search_sort.select_input).val(cooke_sorting_option).change();
      search_sort.priceHighest();
    }
    
    else if(cooke_sorting_option === sorting_options.price_range) {
      $(search_sort.select_input).val(cooke_sorting_option).change();
      search_sort.priceRange();
    }
  }
});
